(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(root) {
      if (root.dataset.catReady) return;
      root.dataset.catReady = '1';
      var track = root.querySelector('[data-cat-track]');
      if (!track) return;
      var prev = root.querySelector('[data-cat-prev]');
      var next = root.querySelector('[data-cat-next]');
      function step() {
        var tile = track.querySelector('.cat-carousel__tile');
        var w = tile ? tile.getBoundingClientRect().width + 16 : 320;
        return w * 1.5;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    }
    function init(scope) {
      (scope || document).querySelectorAll('[data-cat-carousel]').forEach(wire);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const MODELS = {
      'Toyota': ['4Runner', 'Tacoma', 'Tundra', 'FJ Cruiser', 'Land Cruiser', 'Pickup'],
      'Jeep': ['Wrangler JL', 'Wrangler JK', 'Gladiator', 'Cherokee XJ'],
      'Ford': ['Bronco', 'F-150', 'Ranger'],
      'Chevrolet': ['Silverado 1500', 'Colorado'],
      'GMC': ['Sierra 1500', 'Canyon'],
      'RAM': ['1500', '2500', '3500'],
      'Polaris': ['RZR', 'Ranger', 'General'],
      'Can-Am': ['Maverick', 'Defender'],
    };
    const KEY = 'fxn_ymm';

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
    }
    function write(v) {
      try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
    }
    function clear() {
      try { localStorage.removeItem(KEY); } catch (e) {}
    }
    function fromParams() {
      const p = new URLSearchParams(window.location.search);
      const v = {};
      if (p.get('y')) v.y = p.get('y');
      if (p.get('mk')) v.mk = p.get('mk');
      if (p.get('md')) v.md = p.get('md');
      return v;
    }
    function opt(value, label, selected) {
      const o = document.createElement('option');
      o.value = value; o.textContent = label;
      if (selected) o.selected = true;
      return o;
    }

    function initFinder(root) {
      const form = root.querySelector('[data-ymm-form]');
      if (!form) return;
      const yearSel = form.querySelector('[data-ymm-year]');
      const makeSel = form.querySelector('[data-ymm-make]');
      const modelSel = form.querySelector('[data-ymm-model]');
      const clearBtn = form.querySelector('[data-ymm-clear]');
      const saved = read();

      const now = new Date().getFullYear() + 1;
      for (let y = now; y >= 1980; y--) yearSel.appendChild(opt(y, y, String(y) === String(saved.y)));
      Object.keys(MODELS).forEach((mk) => makeSel.appendChild(opt(mk, mk, mk === saved.mk)));

      function fillModels(make, selected) {
        modelSel.innerHTML = '';
        modelSel.appendChild(opt('', 'Model'));
        (MODELS[make] || []).forEach((md) => modelSel.appendChild(opt(md, md, md === selected)));
        modelSel.disabled = !make;
      }
      fillModels(saved.mk, saved.md);
      if (saved.y || saved.mk || saved.md) clearBtn.hidden = false;

      makeSel.addEventListener('change', () => fillModels(makeSel.value));
      clearBtn.addEventListener('click', () => {
        clear();
        yearSel.value = ''; makeSel.value = ''; fillModels('');
        clearBtn.hidden = true;
      });
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const v = { y: yearSel.value, mk: makeSel.value, md: modelSel.value };
        write(v);
        const params = new URLSearchParams();
        if (v.y) params.set('y', v.y);
        if (v.mk) params.set('mk', v.mk);
        if (v.md) params.set('md', v.md);
        const base = root.getAttribute('data-target') || '/collections/all';
        window.location.href = params.toString() ? base + '?' + params.toString() : base;
      });
    }

    function initActive(root) {
      const active = root.querySelector('[data-ymm-active]');
      const empty = root.querySelector('[data-ymm-empty]');
      const current = root.querySelector('[data-ymm-current]');
      const clearBtn = root.querySelector('[data-ymm-clear]');
      const params = fromParams();
      const v = (params.y || params.mk || params.md) ? params : read();
      if (params.y || params.mk || params.md) write(v);

      const label = [v.y, v.mk, v.md].filter(Boolean).join(' ');
      if (label) {
        if (current) current.textContent = label;
        if (active) active.hidden = false;
        if (empty) empty.hidden = true;
      } else {
        if (active) active.hidden = true;
        if (empty) empty.hidden = false;
      }
      if (clearBtn) clearBtn.addEventListener('click', () => {
        clear();
        window.location.href = window.location.pathname;
      });
    }

    function init(scope) {
      (scope || document).querySelectorAll('.fxn-ymm').forEach((root) => {
        if (root.dataset.ymmReady) return;
        root.dataset.ymmReady = '1';
        if (root.classList.contains('fxn-ymm--finder')) initFinder(root);
        else initActive(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
